import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorage, LocalStorageService } from 'ngx-webstorage';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { PatientModel } from 'src/app/models/PatientsModel';
import { formatDate } from '@angular/common';
import { CanserService } from 'src/app/services/CanserService';
import { CanserModel } from 'src/app/models/CanserModel';
import { TranslateService } from '@ngx-translate/core';       /// Change Language
import { DatabankComponent } from '../databank/databank.component';

@Component({
  selector: 'app-search-adv',
  templateUrl: './search-adv.component.html',
  styleUrls: ['./search-adv.component.css'],
})
export class SearchAdvComponent implements OnInit {
  patientCode = '';
  patientFName = '';
  diagnosis = '';
  patientLName = '';
  patientFullName = '';
  birthDate = '2022-01-01';
  education = '';
  nationality = '';
  occupation = '';
  referredFrom = '';
  telHome = '';
  telBusin = '';
  telMobile = '';
  addressHome = '';
  addressBusin = '';
  email = '';
  relativeName = '';
  relativeTelHome = '';
  relativeTelBusin = '';
  relativeTelMobile = '';
  relativeAddressHome = '';
  relativeAddressBusin = '';
  userDef1 = '';
  userDef2 = '';
  userDefDate = '';
  userDefNum = '';
  dateEntry = '';
  gender = '';
  marital = '';
  noChildren = '';
  ageOldest = '';
  ageYoungest = '';
  status = '';
  cancerID = '';
  docCode = '';
  txtRef = '';
  pathology = '';
  menstrual = '';
  since = '';
  contraception = '';
  pregnancy = '';
  smoker = '';
  smokerType = '';
  noPacks = '';
  sSince = 0;
  mSince = '';
  drinkingAlcohol = '';
  deteRelapse = '';
  gov = '';
  compCode = '1';
  userID = 'sa';
  ageYear = 0;
  modifiedDate = '2022-01-01';
  patientList: DatabankModel[] = [];
  cancerlist: CanserModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(
    public pateintssService: DataBankService,
    public patients: DatabankModel,
    public storage: LocalStorageService,
    public patientSelectedData: PatientModel,
    public CanserService: CanserService,
    public cancersModel: CanserModel,
    public translate: TranslateService
  ) {

  }

  ngOnInit(): void {
    this.retrivePatientsTop();
    this.retriveCancersLookupTop();
  }
  retriveCancersLookupTop() {
    this.CanserService.getCancerLookupTop().subscribe((data: CanserModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.cancerlist[i] = data[i];
      }
    });
  }
switchArabic(){
  this.translate.use('ar');
  document.documentElement.dir = "rtl";
}
switchEnglish(){
  this.translate.use('en');
  document.documentElement.dir = "ltr";
}
  retrivePatientsTop() {
    this.pateintssService
      .getpatientLookupTop(this.compCode)
      .subscribe((data: DatabankModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.patientList[i] = data[i];
          data[i].birthDate = formatDate(data[i].birthDate, 'yyyy-MM-dd', 'en');
          this.CanserService.getCancer(data[i].cancerID, this.storage.retrieve('stgcompCode')).subscribe(
            (data: CanserModel) => {
              this.patientList[i].cancerID = data.cancerName;
            }
          );
        }
      });
  }

  retrivePatients() {
    this.patientList = [];

    //if(formatDate(this.birthDate, 'yyyy-MM-dd', 'en') <= '1920/01/01'){return;}

    this.pateintssService
      .getPatientLookup(
        this.patientCode,
        this.patientFName,
        this.telMobile,
        this.telHome,
        this.telBusin,
        this.cancerID,

        this.compCode
      )
      .subscribe((data: DatabankModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.patientList[i] = data[i];
          data[i].birthDate = formatDate(data[i].birthDate, 'yyyy-MM-dd', 'en');
          this.CanserService.getCancer(data[i].cancerID, this.storage.retrieve('stgcompCode')).subscribe(
            (data: CanserModel) => {
              this.patientList[i].cancerID = data.cancerName;
            }
          );
        }

      });
  }
  retrivePatients_Birth(){
    this.patientList = [];

    if(formatDate(this.birthDate, 'yyyy-MM-dd', 'en') <= '1920/01/01'){return;}
    this.pateintssService
      .getPatientBirthLookup(
        this.birthDate,
        this.compCode
      )
      .subscribe((data: DatabankModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.patientList[i] = data[i];
          data[i].birthDate = formatDate(data[i].birthDate, 'yyyy-MM-dd', 'en');
          this.CanserService.getCancer(data[i].cancerID, this.storage.retrieve('stgcompCode')).subscribe(
            (data: CanserModel) => {
              this.patientList[i].cancerID = data.cancerName;
            }
          );
        }

      });
  }
  OpenDialogCall(pa : DatabankModel){
    this.storage.store('stgPatientCode', pa.patientCode);


  }
}
